import { RadioGroupInput } from '@framework/form/inputs/RadioGroupInput.tsx';
import { IsRadioOrCheckboxGroupElementSymbol } from '@framework/form/item/symbols/isRadioOrCheckboxGroupElement.tsx';
import { SelectListOption } from '../../common/option-list/SelectListOption.tsx';
import { getWidgetProps } from '../../common/util/getWidgetProps.ts';
import { type IUseSingleSelectWidgetOptionsReturn } from '../hooks/useSingleSelectWidgetOptions.tsx';
import { type ISingleSelectWidgetComponentProps } from '../SingleSelectWidgetComponent.tsx';
import { SingleSelectOption } from './SingleSelectOption.tsx';

export interface ISingleSelectRadioComponentProps
  extends ISingleSelectWidgetComponentProps,
    IUseSingleSelectWidgetOptionsReturn {}

export function SingleSelectRadioComponent(
  props: ISingleSelectRadioComponentProps,
) {
  const { widget, componentOptions } = props;
  const widgetOptions = getWidgetProps(props);

  return (
    <RadioGroupInput
      name={widgetOptions.name}
      vertical={widget.layout?.direction === 'vertical'}
      readOnly={props.readonly}
    >
      <SelectListOption
        readonly={props.readonly}
        widget={widget}
        options={componentOptions}
        OptionComponent={SingleSelectOption}
        widgetOptions={widgetOptions}
      />
    </RadioGroupInput>
  );
}

SingleSelectRadioComponent[IsRadioOrCheckboxGroupElementSymbol] = true;
